import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LayoutService } from '../../../core/services/layout.service';
import { ModalService } from '../../../core/services/modal.service';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-consignment-split-edit',
  templateUrl: './consignment-split-edit.component.html',
  styleUrls: ['./consignment-split-edit.component.css']
})
export class ConsignmentSplitEditComponent implements OnInit {
    consignmentKeynoSplitFrom;

    public setting?: Setting;

    public selectListPlans: PlanItem[] = [];

    public itemsListSplitEdits: Item[] = [];

    public movingLines = false;

    public tabletMediaQuery: MediaQueryList;

    constructor(private stateService: StateService, private modal: ModalService, layout: LayoutService, private datatask: DataTaskService, private rememberService: RememberService) {
        this.consignmentKeynoSplitFrom = this.stateService.getStateParams()['consignment_keyno_splitfrom'];
        this.tabletMediaQuery = layout.getMediaQueries().tablet;
    }

    private async loadSetting() {
        if (!!this.consignmentKeynoSplitFrom) {
            this.setting = (await this.datatask.Post(1450, { consignment_keyno_splitfrom: this.consignmentKeynoSplitFrom }))[0];
        }
    }

    private async loadPlans() {
        if (!this.setting) return;

        return this.selectListPlans = await this.datatask.Post(1451, { consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom });
    }

    private async loadSplitEdits() {
        if (!this.setting) return;

        if (this.tabletMediaQuery.matches) {
            return this.itemsListSplitEdits = await this.datatask.Post(1449, { consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom });
        } else {
            return this.itemsListSplitEdits = await this.datatask.Post(1449, { consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom });
        }
    }

    public async moveChanges() {
        if (!!this.setting) {
            try {
                this.movingLines = true;

                const selectedLines = (this.itemsListSplitEdits ?? []).map((row) => ({
                    item_id: row['item_id'],
                    item_is_selected: row['item_is_selected'],
                    quantity_total: row['quantity_total']
                }));

                const response = (await this.datatask.Post(1452, {
                    custact_no_consignmentplan: this.setting.custact_no_consignmentplan,
                    consignment_keyno_splitfrom: this.setting.consignment_keyno_splitfrom,
                    records: selectedLines
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.loadSplitEdits();
                }
            } finally {
                this.movingLines = false;
            }
        }
    }

    toggleChosen(item: any): void {
        item = item?.item ? item.item : item;

        if (item.item_id === '0' || item.item_id === '-1') return;

        if (item.item_is_selected === '0') {
            item.item_is_selected = '1';
        } else if (item.item_is_selected === '1') {
            item.item_is_selected = '0';
        }
    }

    private async init() {
        await this.loadSetting();

        Promise.all([
            this.rememberService.remember('w_consignmentsplitedit_last_consignment_keyno_splitfrom', this.setting!.consignment_keyno_splitfrom),
            this.loadPlans()
        ]).then(() => {
            this.loadSplitEdits();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    custact_no_consignmentplan: string;
    consignment_keyno_splitfrom: string;
    gb_consignmentsplitedit: string;
}

interface PlanItem {
    custact_no_consignmentplan: string;
    consignmentplan_name: string;
}
